import { FormFieldRowElementProps } from '../../../../../../types/form';
import FormFieldRowNumber from './FormFieldRowNumber';

export default function FormFieldRowSlider({
  formField,
  index,
}: FormFieldRowElementProps) {
  return <FormFieldRowNumber formField={formField} index={index} />;
}
